function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFolderRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26H4V11.28L5.509 6h7.316l1.371 2.863L14.74 10H28v16zm0-18H16l-1.37-2.863A2 2 0 0012.825 4H5.509c-.894 0-1.678.592-1.923 1.451L2 11v15a2 2 0 002 2h24a2 2 0 002-2V10a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconFolderRexOutline;